// Rails entry point — `react_component 'WorkOrders/SendWorkOrderModal', { ... }`.
//
// The implementation lives in SendWorkOrderModalView.tsx (NOT named after the
// directory): webpack's require.context resolution treats a sibling file named
// after its parent directory as a self-import, yielding an undefined export at
// runtime (see Invoices/SendInvoiceModal and Proposals/SendProposal).
import React, { useCallback, useEffect, useState } from 'react';
import { reloadWithToast } from '@utils/pendingToast';
import SendWorkOrderModalView from './SendWorkOrderModalView';
export { default as SendWorkOrderModal } from './SendWorkOrderModalView';
const AUTO_OPEN_PARAM = 'close_and_send';
export default function Index({ triggerIds = ['wo-close-and-send-report-link'], openOnLoad = false, workOrderId, sendToEmails, subject, body, footer, pdfPath }) {
    const [isOpen, setIsOpen] = useState(openOnLoad);
    const triggerKey = triggerIds.join(',');
    const prefetchPreview = useCallback(() => {
        if (!pdfPath)
            return;
        if (document.head.querySelector(`link[rel="prefetch"][href="${pdfPath}"]`))
            return;
        const link = document.createElement('link');
        link.rel = 'prefetch';
        link.as = 'document';
        link.href = pdfPath;
        document.head.appendChild(link);
    }, [pdfPath]);
    useEffect(() => {
        if (!openOnLoad)
            return;
        const url = new URL(window.location.href);
        if (!url.searchParams.has(AUTO_OPEN_PARAM))
            return;
        url.searchParams.delete(AUTO_OPEN_PARAM);
        window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
    }, [openOnLoad]);
    useEffect(() => {
        const onClick = (event) => {
            event.preventDefault();
            prefetchPreview();
            setIsOpen(true);
        };
        const triggers = triggerKey
            .split(',')
            .filter(Boolean)
            .map((id) => document.getElementById(id))
            .filter((el) => el !== null);
        triggers.forEach((trigger) => {
            trigger.addEventListener('click', onClick);
            trigger.addEventListener('mouseenter', prefetchPreview);
            trigger.addEventListener('focus', prefetchPreview);
        });
        return () => {
            triggers.forEach((trigger) => {
                trigger.removeEventListener('click', onClick);
                trigger.removeEventListener('mouseenter', prefetchPreview);
                trigger.removeEventListener('focus', prefetchPreview);
            });
        };
    }, [triggerKey, prefetchPreview]);
    return (React.createElement(SendWorkOrderModalView, { workOrderId: workOrderId, sendToEmails: sendToEmails, subject: subject, body: body, footer: footer, pdfPath: pdfPath, isOpen: isOpen, onClose: () => setIsOpen(false), onSent: (message) => reloadWithToast(message) }));
}
